"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _cnbuilder = require("cnbuilder");
var _stopDefault = _interopRequireDefault(require("@teladoc/pulse/icons/stop-default.svg"));
var _alertDefault = _interopRequireDefault(require("@teladoc/pulse/icons/alert-default.svg"));
var _FormElementErrorModule = _interopRequireDefault(require("./FormElementError.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["className", "isWarning", "testAttr", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const FormElementError = _ref => {
  let {
      className,
      isWarning,
      testAttr,
      children
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_FormElementErrorModule.default.root, className),
    "data-testid": testAttr
  }, rest), {}, {
    children: [isWarning ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDefault.default, {
      className: _FormElementErrorModule.default.warning
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_stopDefault.default, {}), children]
  }));
};
FormElementError.defaultProps = {
  testAttr: 'form-element-error',
  isWarning: false
};
var _default = exports.default = FormElementError;